/* eslint-disable react/jsx-props-no-spreading */
import { ButtonSize } from 'components/UI_kit_3/Button/Button';
import FormText from 'components/UI_kit_3/FormText/FormText';
import React from 'react';
import { IMaskInputProps, IMaskMixin } from 'react-imask';

// type IMaskInputProps = React.ComponentProps<typeof IMaskInput>;
// export interface IFormTextMaskedProps extends Omit<IMaskInputProps, "size"> {
export interface IFormTextMaskedProps {
  isValid?: boolean;
  isInvalid?: boolean;
  error?: string | boolean | Array<string> | null;
  size?: ButtonSize;
  length?: number;
  label?: string;
  hint?: string;
  requested?: boolean;
  onClear?: () => void;
  Icon?: React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined;
  }
  >;
  qaElementFeedback?:string
  qaElementSuffix?:string
  suffix?:string
}

const FormTextMasked = IMaskMixin<
HTMLInputElement,
IFormTextMaskedProps & IMaskInputProps<HTMLInputElement>
>(({
  inputRef, size, ...props
}) => (
  <FormText ref={inputRef} length={size} size={size} {...props} />
));

export default FormTextMasked;
